var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertifiedInfo = function SvgCertifiedInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 11.908c0-.341.275-.625.625-.625l7.483-.033a.624.624 0 1 1 0 1.25l-7.483.033a.624.624 0 0 1-.625-.625Zm8.125 1.809-7.483.033a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625l7.483-.033a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625Zm3.125-10.384v13.334c0 .575-.467 1.041-1.042 1.041H4.167a1.042 1.042 0 0 1-1.042-1.041V3.333c0-.575.467-1.041 1.042-1.041h11.666c.575 0 1.042.466 1.042 1.041Zm-5.417 2.5.667-.5a.625.625 0 0 1 .75 0l.667.5V3.542h-2.084v2.291Zm4.167-2.291h-.833v3.541c0 .234-.134.45-.35.559a.615.615 0 0 1-.65-.058L12.5 6.616l-1.292.966a.627.627 0 0 1-.658.059.634.634 0 0 1-.342-.559V3.542H4.375v12.916h11.25V3.542Z",
    fill: "current"
  })));
};
export default SvgCertifiedInfo;